export default __webpack_public_path__ + "static/media/footer.2d840da0.png";